import Vue from 'vue';
import VueRouter from 'vue-router';
import RegisterView from '../views/RegisterView.vue';
import SuccessView from '../views/SuccessView.vue'; 

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Register',
    component: RegisterView,
  },
  {
    path: '/success',
    name: 'Success',
    component: SuccessView,
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;